import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, Observable, throwError } from 'rxjs';

export function errorInterceptor(
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  const router = inject(Router);

  return next(request).pipe(
    catchError((error) => {
      if (error.status === 401) {
        router.navigate(['/']);
      }

      const errorMessage =
        error.error?.message ||
        error.message ||
        'Une erreur inattendue est survenue';

      return throwError(() => ({
        status: error.status,
        message: errorMessage,
      }));
    }),
  );
}
